var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.getWidgetName(_vm.element),{tag:"component",attrs:{"element":_vm.element,"number":_vm.number}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }